import { useState } from 'react';
import { uploadImageToCloudinary } from '../utils/uploadCloudinary';

/**
 * Champ logo boutique (création, édition liste, fiche commerçant).
 */
export default function CommercantLogoField({
  logoUrl,
  onLogoChange,
  disabled = false,
  hint = 'Format recommandé : image carrée, PNG ou JPG',
}) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file || disabled) return;
    try {
      setUploading(true);
      const uploadedUrl = await uploadImageToCloudinary(file, 'commercants');
      onLogoChange(uploadedUrl);
    } catch (err) {
      console.error('Erreur upload logo:', err);
      alert('Erreur lors de l\'upload du logo. Veuillez réessayer.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Logo de la boutique
        {uploading && (
          <span className="ml-2 text-xs font-normal text-blue-600">Envoi en cours…</span>
        )}
      </label>
      <div className="flex items-center space-x-4">
        {logoUrl && (
          <div className="flex-shrink-0">
            <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-gray-300 bg-gray-50">
              <img
                src={logoUrl}
                alt="Logo de la boutique"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        )}
        <div className="flex flex-wrap items-center gap-2">
          <label
            className={`cursor-pointer inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 ${
              disabled || uploading ? 'opacity-60 pointer-events-none' : ''
            }`}
          >
            <span>{logoUrl ? 'Changer le logo' : 'Ajouter un logo'}</span>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              disabled={disabled || uploading}
              onChange={handleFile}
            />
          </label>
          {logoUrl && !disabled && (
            <button
              type="button"
              onClick={() => onLogoChange(null)}
              className="text-sm text-red-600 hover:text-red-800"
              disabled={uploading}
            >
              Supprimer
            </button>
          )}
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-1">{hint}</p>
    </div>
  );
}
